import React from 'react';
import './Received_gift.css';

import {Link} from 'react-router-dom';

import { logEvent } from '../../../utils/analytics';
import dates from '../../../utils/dates';

/*
    gift status can be:
    new
    Redeemed
    failed

*/

class Received_gift extends React.Component {
    constructor(props) {
        super(props);

        this.displayRedeemText = this.displayRedeemText.bind(this);
    }
    
    displayRedeemText(){
        if(this.props.gift_status === 'Redeemed') {
            return ({display: 'none'});
        } ;
    }

    render () {
        const isMatchedGift = this.props.gift_type === 'matched';
        const linkTo = isMatchedGift ? `/receive/matched/${this.props.gift_id}` : `/receive/${this.props.gift_id}`;
        return (
            <Link to={linkTo} onClick={() => logEvent('receive: click gift', { source: 'receive_list', gift_status: this.props.gift_status, gift_type: this.props.gift_type || 'regular' })}>
                <div className='gift'>
                    <div className='gift_left_side'>
                        <p className='tiny_text gray'>{dates.jsDate(this.props.delivery_date)}</p>
                        <p className='l1'>{isMatchedGift ? 'Matched gift' : `Gift for: ${this.props.giftTo}`}</p>
                        {isMatchedGift && this.props.matcher_display_name ? <p className='l2'>Matched by: {this.props.matcher_display_name}</p> : null}
                        {isMatchedGift && this.props.giftTo ? <p className='l2'>Gift for: {this.props.giftTo}</p> : null}
                        {!isMatchedGift && <p className='l2'>From: {this.props.gift_from}</p>}
                        {!isMatchedGift && this.props.giftGreeting && <p className='small_text italics'>"{this.props.giftGreeting}"</p>}
                        {this.props.is_matched && !isMatchedGift && (
                            <span className='matched_gift_2x_badge'>2x Matched</span>
                        )}
                        {this.props.is_monthly_gift && (
                            <span className='monthly_gift_badge'>
                                <i className='material-icons monthly_gift_badge_icon'>refresh</i>
                                Monthly
                            </span>
                        )}
                    </div>
                    <div className='gift_right_side'>
                        <p className='tiny_text gray'>&nbsp;</p>
                        <p className='money l1'>{this.props.giftAmount}</p>
                        {
                        this.props.gift_status === 'failed' ?
                        <p style={this.displayRedeemText()} className='small_text gg_red bold l2'>!</p>
                        :
                        this.props.gift_status === 'Redeemed' && !this.props.thank_you_sent && !isMatchedGift ?
                        <Link to={`/receive/${this.props.gift_id}/thank_you`} onClick={(e) => e.stopPropagation()}>
                            <p className='small_text green_text bold l2'>Send Thanks</p>
                        </Link>
                        :
                        <p style={this.displayRedeemText()} className='small_text green_text bold l2'>Redeem</p>
                        }
                    </div>
                </div>
            </Link>
        );
    }
}

export default Received_gift;


/*
    <Link to={`/receive/${this.props.gift_id}`}>
        <div className='gift'>
            <p className='l1'>Gift for {this.props.giftTo}<span className='money'>{this.props.giftAmount}</span></p>
            {this.props.gift_status === 'failed' ?
            <p className='small_text l2'>{this.props.giftGreeting}<span style={this.displayRedeemText()} className='gg_red bold'>!</span></p> :
            <p className='small_text l2'>{this.props.giftGreeting}<span style={this.displayRedeemText()} className='green_text bold'>Redeem</span></p>
            }
        </div>
    </Link>
*/